import React from 'react'

function Footer() {
    return (
        <div>

            <footer className="d-flex flex-wrap justify-content-between  align-items-center py-3 my-4 border-top bg-secondary " id='footer'>
                <div className="col-md-4 d-flex align-items-center " id='foo'>
                © 2021 Go Foodies @ Inc Rahul@ 
                </div>

               
            </footer>

        </div>
    )
}

export default Footer
